<template>
  <v-menu v-model="openMenu" :close-on-content-click="false" left min-width="310px">
    <template v-slot:activator="{ on }">
      <span class="action-btn d-flex align-center" v-on="on">
        <mf-icon fill color="marca-0-l40" size="14" class="mr-1" icon="groups" />
        Lista de destinatários
      </span>
    </template>
    <v-card class="pa-5">
      <v-card-title class="card-title font-weight-bold pa-0 d-flex justify-space-between">
        Lista de destinatários
        <mf-icon fill color="cinza-d20" wght="600" size="22" class="cursor-pointer" icon="close" @click="openMenu = false" />
      </v-card-title>
      <v-card-text class="pa-0 mt-2">
        <v-data-table :headers="headers" :items="emails" hide-default-footer disable-pagination fixed-header :height="emails.length > 5 ? '220px' : ''">
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-left">{{ item }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'SendingList',
  props: {
    emails: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    openMenu: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'E-mail',
          value: 'email',
          align: 'left',
          sortable: false,
        },
      ]
    },
  },
}
</script>
<style scoped lang="scss">
.clear-button {
  text-align: right !important;
  color: $vermelho-d20 !important;
}

.action-btn {
  color: $marca-0-l40;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

::v-deep th,
::v-deep td {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
  height: 37px !important;
}

::v-deep td {
  font-weight: 400;
}
</style>
